/* eslint-disable import/prefer-default-export */
import mainLayoutStore from 'global/MainLayout/store';

export const dispatchSetErrorCode = (errorCode, errorMessage = '') => {
  mainLayoutStore.setState({ errorCode, errorMessage });
};
